import { useMutation } from "@apollo/client/react"; // import { deleteAll } from "app/common/IndexedDb";
import { useAuth } from "@/app/providers"; // import { useMe } from "hooks";
import { useCallback } from "react";
import ReactGA from "react-ga4";
import { useNavigate } from "react-router";
import { LOGIN_AS } from "@/hooks";

export const useLoginAs = () => {
  // const { refetchMe, refetchColors } = useMe();

  const { setToken } = useAuth();

  const navigate = useNavigate();

  const [comLoginAs] = useMutation<any>(LOGIN_AS, {
    onCompleted: (data: any) => {
      // localStorage.clear();
      // deleteAll("cache").then(() => { });

      const res = data?.loginAs || data?.comLoginAs;
      if (res?.token) {
        setToken(res.token);
      }
      navigate("/user-account/profile", {
        state: {
          loginAs: true,
        },
      });
      setTimeout(() => {
        window.location.reload();
      }, 5000);

      // refetchMe();
      // refetchColors();
    },
  });

  const loginAs = useCallback(
    async (email: string) => {
      try {
        await comLoginAs({
          variables: {
            email,
          },
        });

        ReactGA.event({
          category: "Authentication",
          action: "Logout",
          label: email.replace("@", "[at]"),
        });
      } catch {
        /* empty */
      }
    },
    [comLoginAs],
  );

  return {
    loginAs,
  };
};
